import { GraphQlClient } from '@intelipost-js/secure-providers';
import '@babel/polyfill';
import { ScToast } from '@intelipost-js/secure-components';

export default {

  async validateApp({ commit }, args) {
    try {
      const body = {
        app_id: args.app_id.toString(),
        app_config: JSON.stringify(args.app_config),
      };

      const { data } = await GraphQlClient.mutation(`
        mutation ($app_id: String!, $app_config: String!) {
          validateApp(app_id: $app_id, app_config: $app_config) {
                ok
                message
              }
          }
        `, body);

      const validateApp = data.validateApp;

      return Promise.resolve(validateApp);
    } catch (e) {
      ScToast.open({
        message: 'Falha ao validar credenciais',
        duration: 20000,
        type: 'is-danger',
      });
      return Promise.reject(e);
    }
  },

  async stepInstall({ commit, state }, app_id) {
    try {
      const body = {
        app_id: app_id.toString(),
        app_config: JSON.stringify(state.appConfigV2),
      };

      const { data } = await GraphQlClient.mutation(`
        mutation ($app_id: String!, $app_config: String!) {
          stepInstall(app_id: $app_id, app_config: $app_config) {
                ok
                message
                installation_id
              }
          }
        `, body);

      const result = data.stepInstall;

      if (result.ok) {
        commit('setInstallationIdV2', result.installation_id);
      }
      return Promise.resolve(result);
    } catch (e) {
      ScToast.open({
        message: 'Falha ao instalar o aplicativo',
        duration: 20000,
        type: 'is-danger',
      });
      return Promise.reject(e);
    }
  },

  async getCredentials({ commit }, app_id) {
    try {
      const query = await GraphQlClient.query(`
        query {
          GetCredentials(app_id: "${app_id}") {
            sysnode {
              lp_api_key
            }
            ftp {
              host
              username
              password
            }
          }
        }
      `);
      const credentials = query.data.GetCredentials;
      commit('setCredentials', credentials);
      return credentials;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getAppAndInstalation({ commit }, app_id) {
    try {
      const query = await GraphQlClient.query(`
        query {
          appAndInstallation(app_id: "${app_id}"){
            app {
              id
              name
              imgUrl
              description
              subtitle
              schemaBased
              category
              visible
              is_public
              public_doc
              actions {
                operation
                params
              }
             contact
          }
          installation {
              app_id,
              client_id,
              app_config,
              api_key,
              installation_id,
              status,
          }
      }
        }
      `);
      const data = query.data.appAndInstallation;
      commit('setAppDetails', data);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async getWarehouses({ commit }) {
    commit('toggleLoading', true);
    try {
      const query = await GraphQlClient.query(`
        query {
          warehouses {
            id
            name
            federal_tax_payer_id
            address {
              zip_code
            }
          }
        }
      `);
      const data = query.data.warehouses;
      commit('toggleLoading', false);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/store/actions.js